module.exports = __webpack_public_path__ + "static/media/twitter.92d4c452.jpg";